import React from 'react'
import Image from 'next/image'
import { useMediaQuery } from '@helpers/hooks'
import ProductCard from '@components/ui/ProductCard'
import ProductCardHeader from '@components/ui/ProductCard/ProductCardHeader'
import ProductCardProperties, {
  ProductCardPropertiesProps
} from '@components/ui/ProductCard/ProductCardProperties'
import PriceComparison from '@components/ui/PriceComparison'
import { resizeShopifyImage } from '@helpers/shopify'
import imageLoader from '@lib/imageLoader'
import { BREAKPOINT_SIZES } from '@consts/index'
import styles from './styles.module.scss'

export type ModalProductCardProps = {
  image?: string
  productType: string
  productProperties: ProductCardPropertiesProps['properties']
  newProductPropertiesToCompare?: ProductCardPropertiesProps['newPropertiesToCompare']
  price?: {
    paidPrice: number
    fullPrice: string
  }
  classes?: string
}

export const DEFAULT_IMAGE =
  'https://cdn.shopify.com/s/files/1/0076/2131/2569/files/NoProductImageAvailable.jpg'

function ModalProductCard({
  image,
  productType,
  productProperties,
  newProductPropertiesToCompare,
  price,
  classes = ''
}: ModalProductCardProps) {
  const isSmallScreenView = useMediaQuery({
    maxWidth: BREAKPOINT_SIZES.TABLET_LARGE - 1
  })

  const imageSrc =
    !image || image === ''
      ? DEFAULT_IMAGE
      : resizeShopifyImage(image, {
          width: '832',
          height: '1082',
          crop: 'center'
        })

  if (isSmallScreenView) {
    return (
      <div className={styles.modalProductCard__cardDetailsWrapper}>
        <ProductCard
          image={image || DEFAULT_IMAGE}
          title={productType}
          properties={productProperties}
          newPropertiesToCompare={newProductPropertiesToCompare}
          price={price}
          classes={`${styles.modalProductCard__cardDetails__fullWidth} ${classes}`}
        />
      </div>
    )
  }

  return (
    <div className={`${styles.modalProductCard} ${classes}`}>
      <div className={styles.modalProductCard__image}>
        <Image
          src={imageSrc}
          alt={productType}
          width={832}
          height={1082}
          loader={imageLoader}
        />
      </div>
      <div className={styles.modalProductCard__product__detailsDesktop}>
        <ProductCardHeader title={productType}>
          {price && (
            <PriceComparison
              price={price.paidPrice}
              fullPrice={price.fullPrice}
              size="medium-bold"
            />
          )}
        </ProductCardHeader>
        <ProductCardProperties
          properties={productProperties}
          newPropertiesToCompare={newProductPropertiesToCompare}
        />
      </div>
    </div>
  )
}

export default ModalProductCard
